var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteBlMd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "route_bl_md",
    transform: "translate(-1305 -269)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11037",
    "data-name": "Rectangle 11037",
    width: 36,
    height: 36,
    rx: 12,
    transform: "translate(1305 269)",
    fill: "#0078d7",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "insights_black_24dp_1_",
    "data-name": "insights_black_24dp (1)",
    transform: "translate(1311 275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11112",
    "data-name": "Rectangle 11112",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11113",
    "data-name": "Rectangle 11113",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46198",
    "data-name": "Path 46198",
    d: "M21,8a2,2,0,0,0-1.93,2.51l-3.55,3.56a2.037,2.037,0,0,0-1.04,0l-2.55-2.55a2,2,0,1,0-3.86,0L3.51,16.07a2,2,0,1,0,1.42,1.42l4.55-4.56a2.037,2.037,0,0,0,1.04,0l2.55,2.55a2,2,0,1,0,3.86,0l3.56-3.55A2,2,0,1,0,21,8Z",
    transform: "translate(0 -2)",
    fill: "#0078d7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteBlMd);
export default __webpack_public_path__ + "static/media/route_bl_md.75279e451c790c24eb5b8c11f76831e4.svg";
export { ForwardRef as ReactComponent };